import * as moment from 'moment';

import { user as UserApi } from '@teem/constants/api';
import { messages as i18n } from '@teem/constants/messages';
import { getAcronym } from '@teem/helpers/functions';
import { ACTIONS as USER_ACTIONS } from '@teem/core/constants/users';
import * as Api from '@teem/core/constants/api';
import { RemoveUnderscorePipe } from '@teem/pipes/remove-underscore.pipe'
import { TitleCasePipe } from '@angular/common';

export default class UsersTableSchema {
	containerContext: any;
	keyColumn: string = 'uuid';
	serverUrl: string = `${Api.user.all}`;
	headers: Array<object> = [
		{ "label": $localize`:@@ts.user_name:User Name`, "thClass": "th-client pl-3" },
		{ "label": $localize`:@@common.email:Email`, "thClass": "th-client" },
		{ "label": $localize`:@@ts.phone_number:Phone Number`, "thClass": "th-client" },
		{ "label": $localize`:@@ts.user_type:User Type`, "thClass": "th-client" },
		{ "label": "", "thClass": "th-record" }
	];
	cols: Array<object> = [
		{
			"key": "full_name", "tdClass": "td-client-name pl-3",
			"render": (value, row) => `<span class="bt-content"><span class="name-circule" style=background-color:${ row.color ? row.color : '' }>${value ? getAcronym(value) : ''}</span><a class="client-name">${value ? value : ''}</a></span>`,
			"dataClick": (e, value?: any, row?: any) => {
				if (e.target.classList.contains('client-name')) {
					this.containerContext.userActions(USER_ACTIONS.EDIT, row);
				}
			}
		},
		{
			"key": "email", "tdClass": "td-client-name",
			"render": (value) => `${value ? value : ''}`
		},
		{
			"key": "phone", "tdClass": "td-client-name",
			"render": (value) => `${value ? value : ''}`
		},
		{
			"key": "user_type", "tdClass": "td-client-name",
			"render": (value) => {
				let userTrans;
				if (value == 'user') {
					userTrans = 'user.user';
				} else if (value == 'admin') {
					userTrans = 'user.admin';
				} else if (value == 'super_admin') {
					userTrans = 'user.super_admin';
				}
				return `${userTrans ? new TitleCasePipe().transform(new RemoveUnderscorePipe().transform(i18n.t(userTrans))) : ''}`;
			}
		},
		{
			"key": "uuid", "tdClass": "td-editdelete",	  
			"render": (value, row) => {
			  let btn = '';
			  return `<a href="javascript:void(0);" class="delete">
                <svg class="delete-user-btn" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                  <g fill="none" fill-rule="evenodd">
                    <g fill="#FB4575">
                      <path d="M8.25 10.083c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm5.5 0c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm2.75 7.334c0 .505-.41.916-.917.916H6.417c-.506 0-.917-.411-.917-.916V7.333h11v10.084zM9.167 3.967c0-.142.196-.3.458-.3h2.75c.262 0 .458.158.458.3V5.5H9.167V3.967zM19.25 5.5h-4.583V3.967c0-1.177-1.028-2.134-2.292-2.134h-2.75c-1.264 0-2.292.957-2.292 2.134V5.5H2.75c-.504 0-.917.412-.917.917 0 .504.413.916.917.916h.917v10.084c0 1.516 1.234 2.75 2.75 2.75h9.166c1.516 0 2.75-1.234 2.75-2.75V7.333h.917c.504 0 .917-.412.917-.916 0-.505-.413-.917-.917-.917z" transform="translate(-244 -54) translate(244 53) translate(0 1)"/>
                    </g>
                  </g>
                </svg>
              </a>
              <a href="javascript:void(0);" class="edit">
                <svg class="edit-user-btn" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                  <g fill="none" fill-rule="evenodd">
                    <g fill="#1C6AB6">
                      <path d="M12.683 8.444l-2.134-2.137 1.542-1.545 2.133 2.136-1.541 1.546zM7.189 13.95l-2.357.214.209-2.343 4.447-4.453 2.134 2.137-4.433 4.445zm8.174-8.156h-.001l-2.168-2.171c-.587-.586-1.595-.614-2.15-.055L3.92 10.701c-.258.258-.418.6-.451.962l-.3 3.306c-.02.234.062.466.229.632.15.15.351.232.56.232.024 0 .048 0 .071-.003l3.302-.3c.363-.034.704-.193.961-.45l7.123-7.133c.577-.579.552-1.544-.053-2.152z" transform="translate(-875 -616) translate(96 587) translate(779 29)"/>
                    </g>
                  </g>
                </svg>
              </a>`;
			},
			"dataClick": (e, value?: any, row?: any) => {
			  if (e.target.classList.contains('edit') || e.target.classList.contains('edit-user-btn')) {
				this.containerContext.userActions(USER_ACTIONS.EDIT, row);
			  }
			  if (e.target.classList.contains('delete') || e.target.classList.contains('delete-user-btn')) {
				this.containerContext.userActions(USER_ACTIONS.DELETE, row);
			}
			}
		  },
	];

	constructor(container: any) {
		this.containerContext = container;
		
	}

	newColor() {
		return setTimeout(() => {
			let letters = 'BCDEF'.split('');
			let color = '#';
			for (let i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * letters.length)];
			}
			return color;
		}, 200);
	}
}
